import React, { act, useEffect, useState } from 'react';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { AppContext } from '../../contexts/AppContext.js';
import { motion, AnimatePresence, useMotionTemplate } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import i18n from '../../i18n/i18n.js';
import { Utils } from '../../Utils.js';
import CustomerBarcode from '../../components/CustomerBarcode/CustomerBarcode.js';
import BottomSheetSelect from '../../components/BottomSheetSelect/BottomSheetSelect.js';

import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import './OfflineCoupons.css';


const OfflineCoupons = (props) => {

    const appContext = React.useContext(AppContext);
    const { appRef } = appContext;

    const [favoritedShop, setFavoritedShop] = useState(null);
    const [shops, setShops] = useState([]);
    const [offlineCoupons, setOfflineCoupons] = useState([]);
    const [activeOfflineCoupons, setActiveOfflineCoupons] = useState(null);
    const [favoritedShopSelectOpen, setFavoritedShopSelectOpen] = useState(false);
    const [hasSelectedActiveReservedLoyaltyPoints, setHasSelectedActiveReservedLoyaltyPoints] = useState(false);
    const [customerLoyaltyPoints, setCustomerLoyaltyPoints] = useState(0);
    const [redeemedLoyaltyPoints, setRedeemedLoyaltyPoints] = useState(0);
    const [refreshKey, setRefreshKey] = useState(0);

    function renderLabelWithBoldAmount(key, amountText) {
        const amountToken = '__AMOUNT__';
        const translatedLabel = i18n.t(key, { amount: amountToken });
        const parts = translatedLabel.split(amountToken);

        if (parts.length === 1) {
            return translatedLabel;
        }

        return parts.map((part, index) => (
            <React.Fragment key={`${part}-${index}`}>
                {part}
                {index < parts.length - 1 && <strong>{amountText}</strong>}
            </React.Fragment>
        ));
    }

    function activateLoyaltyCoupon(){
        Utils.get_server_data('/set/offline-kuponok',{ajax_event:'set_loyalty_coupon'},{'redeemed_loyalty_points': redeemedLoyaltyPoints}).then(data => {
            if(data.success){
                setRefreshKey(k => k + 1);
            }
            
        }).catch(err => {
            console.error(err);
        });
    }

    function saveFavoritedShop(shopId) {
        
        const realShopId = shopId['target'] ? shopId['target'].value : shopId;

        Utils.get_server_data('/set/offline-kuponok',{ajax_event:'set_favorited_shop'},{'favorited_shop_id': realShopId}).then(data => {
            if(data?.success) {
                setFavoritedShop(realShopId);
            }
        }).catch(err => {
            console.error(err);
        });
    }

    function toggleOfflineCouponActivation(couponId) {
        Utils.get_server_data('/set/offline-kuponok',{ajax_event:'toggle_offline_coupon_activation'},{'offline_coupon_id': couponId}).then(data => {
            if(data?.loaded) {

                // Ha sikeres a művelet, frissítjük az aktív kuponok listáját
                setActiveOfflineCoupons(data.active_offline_coupons);
            }
        }).catch(err => {
            console.error(err);
        });
    }

    useEffect(() => {
        Utils.get_server_data('/get/offline-kuponok',{}).then(data => {
            if(data?.offline_coupons?.favorited_shop_id) {
                setFavoritedShop(data.offline_coupons.favorited_shop_id);
            }
            if(data?.offline_coupons?.shops) {
                setShops(data.offline_coupons.shops);
            }
            if(data?.offline_coupons?.has_active_reserved_loyalty_points) {
                setHasSelectedActiveReservedLoyaltyPoints(data.offline_coupons.has_active_reserved_loyalty_points[0] ? data.offline_coupons.has_active_reserved_loyalty_points[0] : false);
            }
            if(data?.offline_coupons?.customer_loyalty_points) {
                setCustomerLoyaltyPoints(data.offline_coupons.customer_loyalty_points);
                setRedeemedLoyaltyPoints(data.offline_coupons.customer_loyalty_points);
            }
            if(data?.offline_coupons?.offline_coupons) {
                setOfflineCoupons(data.offline_coupons.offline_coupons);
            }
            if(data?.offline_coupons?.active_offline_coupons) {
                setActiveOfflineCoupons(data.offline_coupons.active_offline_coupons);
            }
        }).catch(err => {
            console.error(err);
        });
    }, [favoritedShop, refreshKey]);

    return <div className='container floating_container offline-coupons'>
        <div className='floating_container_inner'>
            <PageHeader title={i18n.t('offlineCouponsTitle')} isHistoryBack={true} no_close={true} custom_icons={[<CustomerBarcode />]} callback={() => {}}>
                <span className='offline-coupons-desc'>{i18n.t('offlineCouponsDescription')}</span>
            </PageHeader>
            <div className='floating_container_content'>
                
                <div className='favorited-shop-block'>
                    <h3>{i18n.t('offlineCouponsFavoritedShopTitle')} <button className='set-favorited-shop-btn' onClick={() => setFavoritedShopSelectOpen(true)}>{i18n.t('offlineCouponsFavoritedShopButtonLabel')}</button></h3>
                    {parseInt(favoritedShop) > 0 ? 
                        <div className='favorited-shop'><span className='favorited-shop-label'>{shops[favoritedShop]?.label_txt}</span>{shops[favoritedShop]?.address_txt || ''}</div> 
                        : 
                        <div className='favorited-shop'>
                            <span className='favorited-shop-label'>{i18n.t('offlineCouponsFavoritedShopSet')}</span>
                            {i18n.t('offlineCouponsFavoritedShopSetDesc')}
                        </div>
                    }
                </div>

                {hasSelectedActiveReservedLoyaltyPoints || customerLoyaltyPoints > 0 ?
                    <div className='loyalty-points-block'>
                        <h3>{i18n.t('offlineCouponsLoyaltyPointsTitle')}</h3>
                        {hasSelectedActiveReservedLoyaltyPoints && (
                            <div className='loyalty-points-reserved'>
                                <span className='loyalty-points-reserved-label'>
                                    <span className='loyalty-points-is-activated-label'>{i18n.t('offlineCouponsLoyaltyPointsIsActivatedLabel')}</span>
                                    <span className='loyalty-points-is-activated'>{i18n.t('offlineCouponsLoyaltyPointsActiveLabel')}</span>
                                    <br/>
                                    {renderLabelWithBoldAmount(
                                        'offlineCouponsLoyaltyPointsReservedLabel',
                                        Utils.format_currency(hasSelectedActiveReservedLoyaltyPoints.reserved_loyalty_points_int, appRef.current.currency_settings)
                                    )}
                                </span>
                            </div>
                        )}
                        {!hasSelectedActiveReservedLoyaltyPoints && customerLoyaltyPoints > 0 && (
                            <div className='loyalty-points-available'>
                                <span className='loyalty-points-available-label'>
                                    {renderLabelWithBoldAmount(
                                        'offlineCouponsLoyaltyPointsBeforeRedeemLabel',
                                        Utils.format_currency(redeemedLoyaltyPoints, appRef.current.currency_settings)
                                    )}
                                </span>
                                
                                <span className='loyalty-points-before-redeem-desc'>
                                    {i18n.t('offlineCouponsLoyaltyPointsBeforeRedeemDesc')}
                                </span>

                                <div className='loyalty-points-slider-block'>
                                    <RangeSlider
                                        value={[0, redeemedLoyaltyPoints]}
                                        min={0}
                                        max={customerLoyaltyPoints}
                                        step={1}
                                        thumbsDisabled={[true, false]}
                                        rangeSlideDisabled={true}
                                        onInput={(values) => setRedeemedLoyaltyPoints(values[1])}
                                    />
                                </div>
                                <div className='activate-loyalty-coupon-button-cont'>
                                    <button className='activate-loyalty-coupon-button' onClick={activateLoyaltyCoupon}>
                                        {i18n.t('offlineCouponsActivateLoyaltyCouponButton')}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                : ''}

                <div className='offline-coupons-list'>
                    <h3>{i18n.t('offlineCouponsTitle')}</h3>
                    {offlineCoupons.length > 0 ?
                        offlineCoupons.map(coupon => (
                            <div key={coupon.id} className={`offline-coupon shop-card-bg shop-card-shadow`}>
                                <div className='offline-coupon-item-flex'>
                                    <div className='offline-coupon-image'>
                                        {coupon.image_file && <img src={coupon.image_file} alt={coupon.label_txt} />}
                                    </div>
                                    <div className='offline-coupon-content'>
                                        <div className='offline-coupon-header-row'>
                                            <span className='offline-coupon-title'>{coupon.label_txt}</span>
                                            {activeOfflineCoupons?.includes(coupon.id) ? (
                                                <span onClick={() => toggleOfflineCouponActivation(coupon.id)} className='offline-coupon-badge offline-coupon-badge--active'>{i18n.t('offlineCouponsActive')}</span>
                                            ) : (
                                                <span onClick={() => toggleOfflineCouponActivation(coupon.id)} className='offline-coupon-badge offline-coupon-badge--inactive'>{i18n.t('offlineCouponsInactive')}</span>
                                            )}
                                        </div>
                                        <div className='offline-coupon-description'>{coupon.short_description_blob}</div>
                                        <div className='offline-coupon-validity'>
                                            {i18n.t('offlineCouponsValidity')} 
                                            {coupon.start_time_int && parseInt(coupon.start_time_int) !== 0 ? new Date(parseInt(coupon.start_time_int) * 1000).toLocaleDateString() : ''}
                                            {((coupon.start_time_int && parseInt(coupon.start_time_int) !== 0) || (coupon.end_time_int && parseInt(coupon.end_time_int) !== 0)) && ' - '}
                                            {coupon.end_time_int && parseInt(coupon.end_time_int) !== 0 ? new Date(parseInt(coupon.end_time_int) * 1000).toLocaleDateString() : i18n.t('offlineCouponsValidityNoEnd')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    :
                        <div className='no-offline-coupons'>{i18n.t('offlineCouponsNoCoupons')}</div>
                    }
                </div>

                <BottomSheetSelect
                    isOpen={favoritedShopSelectOpen}
                    onClose={() => setFavoritedShopSelectOpen(false)}
                    options={Object.values(shops).map(shop => ({ value: shop.incache_id_txt, label: shop.label_txt }))}
                    onChange={(value) => saveFavoritedShop(value)}
                    selectedValue={favoritedShop}
                    title={i18n.t('offlineCouponsFavoritedShopTitle')}
                />
            </div>
        </div>
    </div>;
}

export default OfflineCoupons;
